import { AlertTriangle, RotateCcw } from "lucide-react";

export const LoadError = ({ message = "This record could not be loaded.", onRetry, testId = "load-error" }) => (
  <div data-testid={testId} className="bg-[#0F2E23] rounded-xl border border-red-400/25 p-8 text-center">
    <AlertTriangle className="w-7 h-7 text-red-300 mx-auto" />
    <p className="mt-3 text-sm text-emerald-100/80">{message}</p>
    {onRetry && (
      <button data-testid={`${testId}-retry`} onClick={onRetry} className="mt-4 inline-flex items-center gap-1.5 text-sm bg-brass text-emerald-950 font-semibold rounded-lg px-4 py-2">
        <RotateCcw className="w-4 h-4" /> Retry
      </button>
    )}
  </div>
);

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (!e?.response) return "Network problem — check your connection and retry.";
  return fallback;
};

export const asText = (v) => (Array.isArray(v) ? v.filter(Boolean).join(", ") : v ? String(v) : "");
